import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Proof } from '@feature/proof';
import { generateProofApi, generateProofOptions } from '@feature/proof/proofGenerator';
import { Id } from '@feature/utils';

const courseProofApi = generateProofApi('/proof-file/course');
const { getProofsOptions, getProofsByOwnerOptions, createOrUpdateProofOptions, deleteProofOptions } =
  generateProofOptions('course', courseProofApi);

export function getCourseProofsByOwnerOptions(courseId: Id, userId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsByOwnerOptions(courseId, userId);
}

export function getCourseProofsOptions(courseId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsOptions(courseId);
}

export function useUploadOrUpdateCourseProof(courseId: Id) {
  const queryClient = useQueryClient();
  return useMutation(createOrUpdateProofOptions(courseId, queryClient));
}

export function useDeleteCourseProof(courseId: Id) {
  const queryClient = useQueryClient();
  return useMutation(deleteProofOptions(courseId, queryClient));
}
